import PropTypes from "prop-types";
import React from "react";

const ReadOnly = ({showDesc, title}) => {
  return (
    <span className="ReadOnly">
      <span
        className="erg-margin-right-5 text-info"
        title={!showDesc ? title : ""}>
        <i className="fa fa-lock" />
      </span>
      {showDesc ? <span className="icon-desc">{title}</span> : null}
    </span>
  );
};

ReadOnly.propTypes = {
  showDesc: PropTypes.bool,
  title: PropTypes.string,
};

ReadOnly.defaultProps = {
  title: "Item can't be modified",
};

export default ReadOnly;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/icons/ReadOnly.js
 **/